import { dayjs, formatRaceDateString } from '@mobi/utils/date'
import { get } from '@classic/Foundation/Services/ApiService'

export function fetchData(url: string) {
  return get({ url: '/$_/racingform/' + url })
}

export const toLocalTime = (date: Date | string, format: string) =>
  dayjs(date).local().format(format)

export const makeDate = (date: string): Date => dayjs(date).toDate()

export const formatDate = (date: Date | string) => dayjs(date).format(dateFormat)

export const formatDateForServer = (date: string) => {
  const regExp = /\(([^)]+)\)/
  const matches = regExp.exec(date)

  if (!matches || !matches[1]) return ''
  const timeInMs = matches[1].split('+')[0]

  const formattedDate = formatRaceDateString(new Date(timeInMs).toDateString())

  return formattedDate
}
export const dateTimeFormat = 'HH:mm, DD MMM YYYY'
export const dateFormat = 'ddd, DD MMM YYYY'
export const machineFormat = 'YYYY-MM-DDTHH:mm'
